import React, { useEffect } from 'react'
import BangGiaQuay from '../../components/BangGiaQuay'
import ScrollToTop from "../../components/ScrollToTop";
import BangGiaQuayBanner from '../../components/Banner/BangGiaQuayBanner';
export default function BangGia() {
    useEffect(() => {
        document.title = 'MinMin Wedding - Phóng Sự Cưới | Bảng giá quay';
    }, []);
    return (
        <>
            <ScrollToTop />
            <BangGiaQuayBanner />
            <div>
                <BangGiaQuay />
            </div>

        </>
    )
}